import { sql } from "drizzle-orm";

import type { WsPublishedWorkflowItem } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { publishedWorkflowItem } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

export async function bulkUpsertPublishedWorkflowItem(records: WsPublishedWorkflowItem[]) {
  if (records.length === 0) return;
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(publishedWorkflowItem, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [publishedWorkflowItem.id],
      set: {
        workflowItemId: sql`excluded."workflowItemId"`,
        broadcastId: sql`excluded."broadcastId"`,
        accountId: sql`excluded."accountId"`,
        workspaceId: sql`excluded."workspaceId"`,
        contentId: sql`excluded."contentId"`,
        createdAt: sql`excluded."createdAt"`,
      },
    },
  });
  emitTableUpdates(["published_workflow_item"]);
}
